import fdo from '@comrun/kfdo'

export default {
  methods: {
    toProtoDateTime(dateTime) {
      return new fdo.kkm.proto.DateTime({
        date: new fdo.kkm.proto.Date({ year: this.$moment(dateTime).format('YYYY'), month: this.$moment(dateTime).format('M'), day: this.$moment(dateTime).format('D') }),
        time: new fdo.kkm.proto.Time({ hour: this.$moment(dateTime).format('HH'), minute: this.$moment(dateTime).format('mm'), second: this.$moment(dateTime).format('ss') }),
      })
    },
  },
}
